// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-opportunity-footer {
  height: 60px;
  background-color: #ddd;
  display: flex;
  align-items: center;
  padding: 0 20px;
}

.react-datepicker-wrapper {
  width: 90%;
}`, "",{"version":3,"sources":["webpack://./src/pages/Opportunities/EditOpportunity/EditOpportunity.scss"],"names":[],"mappings":"AAGA;EACC,YAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAFD;;AAKA;EACC,UAAA;AAFD","sourcesContent":[".edit-opportunity-container {\n}\n\n.edit-opportunity-footer {\n\theight: 60px;\n\tbackground-color: #ddd;\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 0 20px;\n}\n\n.react-datepicker-wrapper {\n\twidth: 90%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
